import axios from 'axios';
import { getToken } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;
const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const getWishlist = () => axios.get(`${BASE_URL}/wishlist`, { headers: authHeader() });
export const toggleWishlist = (productId) => axios.post(`${BASE_URL}/wishlist/${productId}`, {}, { headers: authHeader() });
export const getWishlistStatus = (productId) => axios.get(`${BASE_URL}/wishlist/${productId}/status`, { headers: authHeader() });